import { last } from "@pdfking/rfunc"
import { Composition } from "@pdfking/tfunc"
import split_filename from "./split_filename"

// @ts-expect-error TS2352
export default Composition(split_filename, last) as (filename: string) => string
